export default __webpack_public_path__ + "c90849dc9af4f00c21e9c8d61033055e.png";